import { render, staticRenderFns } from "./QuestionOpen.vue?vue&type=template&id=2dec9fba&scoped=true&"
import script from "./QuestionOpen.vue?vue&type=script&lang=js&"
export * from "./QuestionOpen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dec9fba",
  null
  
)

export default component.exports